import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * Redirect component for /share/nft/:id route.
 * This handles the case when a human user navigates to /share/nft/:id within the SPA.
 * The _redirects file handles the server-side proxy for bots.
 */
export default function ShareNftRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      navigate(`/nft/${id}`, { replace: true });
    } else {
      navigate("/marketplace", { replace: true });
    }
  }, [id, navigate]);

  return null;
}
